import { createKey } from './createKey';

const keyHandler = createKey('job-status');

export const JobStatusServiceKeys = {
  key: keyHandler.key,
  get: keyHandler.createMethod(),
};
